var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"score t-bold u-black u-center",class:{'is-wiggle': _vm.isWiggle}},[_vm._v(" "+_vm._s(_vm.score)+" / "+_vm._s(_vm.question)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }